module.exports = __webpack_public_path__ + "media/auth-bg-2.f3ffd469.mp4";